<template>
  <v-toolbar
    app
    fixed
    clipped-left
    color="primary"
    dark
  >
    <v-toolbar-side-icon
      v-if="user"
      @click="$parent.$emit('toggleDrawer')"
    />
    <v-btn
      :icon="true"
      @click="$router.push('/')"
    >
      <v-icon>
        home
      </v-icon>
    </v-btn>
    <v-toolbar-title>
      <company-dropdown
        v-if="user"
      />
    </v-toolbar-title>
    <v-spacer />
    <v-toolbar-items>
      <template v-if="user">
        <user-dropdown />
      </template>

      <template v-else>
        <v-btn
          flat
          @click="login"
        >
          Login
        </v-btn>
      </template>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyDropdown from './CompanyDropdown'
import UserDropdown from './UserDropdown'

export default {
  components: {
    CompanyDropdown,
    UserDropdown
  },

  data: () => ({
    appName: window.config.appName
  }),

  computed: mapGetters({
    user: 'auth/user'
  }),

  methods: {
    login () {
      this.$router.push({ name: 'login' })
    },
    register () {
      this.$router.push({ name: 'register' })
    }
  }
}
</script>

<style scoped>
  .appName {
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/Navbar.vue